import React, { useEffect, useState } from 'react';
import exifr from 'exifr';
import styled from 'styled-components';
import { ImageDataProps, LeftToolGroupSt } from './LeftToolGroup';

const OpenImage = ({ mapInstance, objectPhoto, imageList, setImageList, fileList, setFileList, setHide, imagePopup }) => {
  const onChange = (e) => {
    const newArr: ImageDataProps[] = [];
    const newArr2: string[] = [];
    const files = [...e.target.files];
    const prom = files.map(async (file) => {
      const readFileAsync = () => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(new Blob([file]));
        });
      };

      await exifr.parse(file, { xmp: true, tiff: true }).then(async (i) => {
        console.log(i);
        if (i.latitude && i.longitude) {
          await readFileAsync().then((j) => {
            newArr.push({
              lat: i.latitude,
              lon: i.longitude,
              createdDate: i.CreateDate,
              fileName: file.name,
              checked: false,
              data: j,
            });
          });
          newArr2.push(file.name);
        }
      });
    });
    Promise.all(prom).then(() => {
      setImageList(newArr);
      setFileList(newArr2);
    });
  };

  useEffect(() => {
    if (imageList.length) {
      objectPhoto?.draw(imageList);
      objectPhoto.onClickFeature(imageList, setImageList, setHide);
    } else {
      // objectPhoto.destroy();
    }
  }, [fileList]);

  // imagePopup 데이터 변동시, zoom이벤트 추가
  useEffect(() => {
    if (imagePopup) {
      let scale = 1;
      let isDragging = false;
      let startX,
        startY,
        currentX = 0,
        currentY = 0;

      // 컨테이너
      const container: any = document.getElementById('imageContainer');
      container.addEventListener('mouseleave', () => {
        isDragging = false;
      });

      // 이미지의 위치를 컨테이너 안에 제한하는 함수
      function limitImagePosition(img) {
        const containerRect = container.getBoundingClientRect();
        // 중요) 확대된 이미지의 실제 크기 계산
        const imgWidth = containerRect.width * scale; // img크기는 container랑 동일하게 설정했다는 가정(css)
        const imgHeight = containerRect.height * scale;

        // 이미지 스케일이 1일때 바로 0처리
        if (scale === 1) {
          currentX = 0;
          currentY = 0;
        } else {
          // x축 경계 처리 (왼쪽 및 오른쪽)
          const maxX = (imgWidth - containerRect.width) / 2 / scale - 1; // 1px만큼 갭이 생겨서 빼줌
          const minX = -maxX;

          if (imgWidth > containerRect.width) {
            currentX = Math.max(minX, Math.min(currentX, maxX));
          } else {
            currentX = 0;
          }

          // y축 경계 처리 (위쪽 및 아래쪽)
          const maxY = (imgHeight - containerRect.height) / 2 / scale - 1; // 1px만큼 갭이 생겨서 빼줌
          const minY = -maxY;

          if (imgHeight > containerRect.height) {
            currentY = Math.max(minY, Math.min(currentY, maxY));
          } else {
            currentY = 0;
          }
        }

        img.style.transformOrigin = `center center`; // 이미지 중심 기준 (left top 등)
        img.style.transform = `scale(${scale}) translate(${currentX}px, ${currentY}px)`;
      }

      function wheelEvent(event) {
        event.preventDefault();

        const zoomSpeed = 0.1;
        if (event.deltaY < 0) {
          scale += zoomSpeed;
        } else {
          scale = Math.max(1, scale - zoomSpeed); // 최소 축소 크기는 1
        }

        // 확대 시 이미지 경계를 체크하고 조정
        limitImagePosition(event.target);
      }

      // 드래그 시작
      function startDrag(event) {
        event.preventDefault();
        container.style.cursor = 'grabbing';
        isDragging = true;
        startX = event.clientX - currentX;
        startY = event.clientY - currentY;
      }

      // 드래그 중
      function duringDrag(event) {
        event.preventDefault();

        if (isDragging) {
          currentX = event.clientX - startX;
          currentY = event.clientY - startY;

          limitImagePosition(event.target);
        }
      }

      // 드래그 종료
      function stopDrag() {
        container.style.cursor = 'grab';
        isDragging = false;
      }

      // 이미지 확대/축소 및 드래그 기능 추가
      function addZoomAndDrag(img) {
        img.addEventListener('wheel', wheelEvent);
        img.addEventListener('mousedown', startDrag);
        img.addEventListener('mousemove', duringDrag);
        img.addEventListener('mouseup', stopDrag);
      }

      // 이미지 확대/축소 및 드래그 기능 제거
      function removeZoomAndDrag(img) {
        img.removeEventListener('wheel', wheelEvent);
        img.removeEventListener('mousedown', startDrag);
        img.removeEventListener('mousemove', duringDrag);
        img.removeEventListener('mouseup', stopDrag);
        img.style.transform = `scale(1) translate(0px, 0px)`; // 이미지 원위치
      }

      // 이미지 객체
      const img = document.getElementById('zoomableImage');
      if (img) {
        addZoomAndDrag(img); // 이벤트 추가
      }

      return () => {
        if (img) {
          removeZoomAndDrag(img); // 이벤트 삭제
        }
      };
    }
  }, [imagePopup]);

  return (
    <>
      <LeftToolGroupSt.UploadLabel htmlFor={'fileUpload'}>업로드</LeftToolGroupSt.UploadLabel>
      <input id={'fileUpload'} type={'file'} multiple={true} onChange={onChange} style={{ display: 'none' }} />
    </>
  );
};

export default OpenImage;
